let accordionCounter = 0;

export function initAccordions() {
	$('.js_accordion-head').each((_, element) => {
		const count = ++accordionCounter;
		element.setAttribute('role', 'button');
		element.setAttribute('aria-controls', `accordion-slide-${count}`);
		$(element).next('.js_accordion-slide').attr('id', `accordion-slide-${count}`);

		const slide = $(element).next('.js_accordion-slide').get(0);
		const isOpen = window.getComputedStyle(slide).display === 'block';
		element.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		slide.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
	});

	$('.js_accordion-head').on('click', function () {
		const element = $(this).get(0);
		const slide = $(this).next('.js_accordion-slide').get(0);
		$(this).next('.js_accordion-slide').slideToggle(500, () => {
			const isOpen = window.getComputedStyle(slide).display === 'block';
			element.classList.toggle('open', isOpen);
			element.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
			slide.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
		});
	});

	let resizeTimer;
	$(window).on('resize', function () {
		clearTimeout(resizeTimer);

		// execute breakpointChange() once the viewport
		// has stopped changing in size for 400ms
		resizeTimer = setTimeout(function () {
			if (window.innerWidth > 768) {
				$('.js_accordion-slide').removeAttr('style');
			}
		}, 200);
	});
}
